import request from '@/utils/request'


// 对外暴露登录接口函数
export function login(data) {
  return request({
    url: '/Auth/Login/Login',
    method: 'post',
    data
  })
}

// 对外暴露获取用户信息的函数
export function getvalidcode(data) {
  return request({
    url: '/Auth/Login/getvalidcode',
    method: 'get',
    params: data
  })
}

// 对外暴露获取用户信息的函数
export function getInfo() {
  return request({
    url: '/Auth/Login/GetCurrentLoginUserInfo',
    method: 'get',
  })
}

// 对外暴露退出登录函数
export function logout() {
  return request({
    url: '/Auth/Login/logout',
    method: 'post',
  })
}

// 对外暴露退出登录函数
export function ResetPwd(data) {
  return request({
    url: '/User/User/ResetPwd',
    method: 'get',
    params: data
  })
}
